const makeKlarnaPayment = async ({ paymentIntent, stripe, paymentPopupData }) => {
    const data = {
        isSuccessFull: false
    };
    try {
        const { result, error } = await stripe.confirmKlarnaPayment(paymentIntent.client_secret, {
            payment_method: {
                billing_details: {
                    email: paymentPopupData?.email,
                    address: {
                        country: "NO"
                    }
                }
            },
            return_url: "https://zealous-pebble-0ee447b03-testing.westeurope.2.azurestaticapps.net/feed"
        });
        if (error) {
            return data;
        }
        data.isSuccessFull = result?.paymentIntent?.status?.toLowerCase() === "succeeded";
        return data;
    } catch (error) {
        return data;
    }
};
export { makeKlarnaPayment };
